import {
  takeLatest, put, call, select
} from 'redux-saga/effects';

import dayjs from 'dayjs';
import { isEmpty, isNil } from 'ramda';

import Utils from 'src/utils';
import {
  workHoursActions,
  getWorkHoursExportId
} from 'src/store/reducers/workHoursExportReducer/workHoursReducer';
import { workHoursExportActions } from 'src/store/reducers/workHoursExportReducer/workHoursExportReducer';

import toastrError from 'src/helpers/toastr/toastrError';
import { wtsApi } from 'src/api';
import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';
// eslint-disable-next-line func-names
export default function* () {
  yield [
    takeLatest(workHoursActions.request, workHoursExportSaga),
    takeLatest(workHoursExportActions.request, workHoursExportRequestSaga)
  ];
}

function* workHoursExportSaga({ values }) {
  try {
    const params = {
      currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss'),
      ...values
    };
    const response = yield call(wtsApi.reports.workingHoursExportValuesList, params);
    const responseData = response.data.Data;
    if (isNil(responseData) || isEmpty(responseData)) {
      toastr.error(I18n.t('NoDataAvailable'));
    } else {
      const { Id: id, Values: data } = responseData;
      const list = data.map(Utils.objects.decapitalizeObject);

      yield put({
        type: workHoursActions.success,
        payload: { id, list }
      });
    }
  } catch (e) {
    yield put({
      type: workHoursActions.fail,
      payload: e.message
    });
    toastrError(e);
    console.log(e);
  }
}

function* workHoursExportRequestSaga() {
  try {
    yield put({ type: workHoursExportActions.show });

    const id = yield select(getWorkHoursExportId);

    const responseData = yield call(wtsApi.exports.workHoursCreate, {
      location: 'Axapta',
      report: `WorkingHoursExportValues_${id}`
    });
    const response = responseData.data;

    const {
      Data: data,
      ResultId: resultId,
      ResultMsg: resultMsg
    } = response || {};

    if (resultId !== 0) { // On error resultId will be non-zero value
      const errors = data && !isEmpty(data)
        ? data.map(Utils.objects.decapitalizeObject)
        : [{
          resultMsg,
          resultId
        }];

      yield put({
        type: workHoursExportActions.fail,
        payload: errors
      });
    } else {
      yield put({ type: workHoursExportActions.success });
    }
  } catch (e) {
    yield put({
      type: workHoursExportActions.hide
    });

    toastrError(e);
  }
}
